/**
 * © Moustapha HENNAWI - Click and Take off - 2021
 */

/*-------------------------------------------------------------------------------------------*/

import { createSlice } from '@reduxjs/toolkit';

/*-------------------------------------------------------------------------------------------*/

const { reducer, actions } = createSlice(
  {
    name: 'session',
    initialState: {
      authenticated: false,
      abonnement: null,
      items: {},
      lastFreeFlight: null
    },
    reducers: {
      authenticated(state, action) {
        state.authenticated = action.payload;
      },
      abonnement(state, action) {
        state.abonnement = action.payload;
      },
      update(state, action) {
        state.items = action.payload;
      },
      lastFreeFlight(state, action) {
        state.lastFreeFlight = action.payload;
      }
    }
  }

  /*-------------------------------------------------------------------------------------------*/
);
export { actions as sessionActions };
export { reducer as sessionReducer };
/*-------------------------------------------------------------------------------------------*/
